import { defineComponent, computed } from 'vue';

export default defineComponent({
    name: 'error',
    props: {
        errorMessage: String
    },
    setup: function (props, ctx) {
        return {

        };
    }
});